
import React from 'react';
import ChangePasswordForm from '../../components/change-password-form/ChangePasswordForm';


export default function ChangePasswordView() {

    
    return (
        <ChangePasswordForm open={true} onClose={() => {}} />
    );
  }
